// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"827":"43d510c5","990":"7bd7030f"}[chunkId] + ".chunk.js";
};